import { AwesomeEvent, ComponentAPI, Value } from '@philips-emr/tws-core';
import Changeable, { ChangeEventListener } from '@philips-emr/tws-core/lib/component/types/changeable';
import Focusable, { FocusEventListener } from '@philips-emr/tws-core/lib/component/types/focusable';

class AutocompleteAPI extends ComponentAPI implements Changeable<Record<string, Value>>, Focusable {
  /** @event */
  @AwesomeEvent
  onBlur = new FocusEventListener();

  /** @event */
  @AwesomeEvent
  onChange = new ChangeEventListener<Record<string, Value>>();

  /** @event */
  @AwesomeEvent
  onFocus = new FocusEventListener();

  getClassName(): string {
    return this.state.className;
  }

  setClassName(className: string): void {
    this.setState({ className });
  }

  getEmptyResultExpression(): string {
    return this.state.emptyResultExpression;
  }

  setEmptyResultExpression(emptyResultExpression: string): void {
    this.setState({ emptyResultExpression });
  }

  isEnabled(): boolean {
    return this.state.enabled;
  }

  setEnabled(enabled: boolean): void {
    this.setState({ enabled });
  }

  getEntry(): string {
    return this.state.entry;
  }

  setEntry(entry: string): void {
    this.setState({ entry });
  }

  getLimit(): number {
    return this.state.limit;
  }

  setLimit(limit: number): void {
    this.setState({ limit });
  }

  getMinSearchLength(): number {
    return this.state.minSearchLength;
  }

  setMinSearchLength(minSearchLength: number): void {
    this.setState({ minSearchLength });
  }

  getPlaceholder(): string {
    return this.state.placeholder;
  }

  setPlaceholder(placeholder: string): void {
    this.setState({ placeholder });
  }

  getPrimaryKey(): string {
    return this.state.primaryKey;
  }

  setPrimaryKey(primaryKey: string): void {
    this.setState({ primaryKey });
  }

  getQueryKey(): string {
    return this.state.queryKey;
  }

  setQueryKey(queryKey: string): void {
    this.setState({ queryKey });
  }

  isReadOnly(): boolean {
    return this.state.readOnly;
  }

  setReadOnly(readOnly: boolean): void {
    this.setState({ readOnly });
  }

  getTitle(): string {
    return this.state.title;
  }

  setTitle(title: string): void {
    this.setState({ title });
  }

  getValue(): Record<string, Value> {
    return this.state.internalValue;
  }

  setValue(value: Record<string, Value>): void {
    this.setState({ value });
  }
}

export default AutocompleteAPI;
